<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { copyTextToClipboard } from 'shared/helpers/clipboard';
import VisitSchedulingLinksAPI from 'custom/dashboard/api/visitSchedulingLinks';

import NextButton from 'dashboard/components-next/button/Button.vue';

// Copies the conversation's public visit scheduling link without sending anything, for the
// agent who wants to paste it into a message of their own. The link comes from the backend
// (see VisitScheduling::LinkBuilder) so it follows exactly the rules the public page
// enforces — which is also why a conversation the page would reject answers 404 here and
// the agent is told so instead of being handed a dead link.
const props = defineProps({
  conversationId: {
    type: [Number, String],
    required: true,
  },
});

const { t } = useI18n();

const isCopying = ref(false);

const copyLink = async () => {
  isCopying.value = true;
  try {
    const { data } = await VisitSchedulingLinksAPI.show(props.conversationId);
    await copyTextToClipboard(data.url);
    useAlert(t('MACROS.VISIT_SCHEDULING_LINK.COPIED'));
  } catch (error) {
    useAlert(t('MACROS.VISIT_SCHEDULING_LINK.ERROR'));
  } finally {
    isCopying.value = false;
  }
};
</script>

<template>
  <NextButton
    v-tooltip.left-start="$t('MACROS.VISIT_SCHEDULING_LINK.TOOLTIP')"
    data-testid="copy-visit-scheduling-link"
    icon="i-lucide-link"
    slate
    faded
    xs
    :is-loading="isCopying"
    @click="copyLink"
  />
</template>
